import React from 'react';

function Card({
  children,
  className = '',
  interactive = false,
  ...props
}) {
  const interactiveClasses = interactive
    ? 'hover:border-slate-300 hover:shadow-md focus-within:border-slate-300 focus-within:shadow-md'
    : '';

  return (
    <section
      className={`rounded-2xl border border-slate-200 bg-white shadow-sm transition-[border-color,box-shadow,transform] duration-150 motion-reduce:transition-none ${interactiveClasses} ${className}`}
      {...props}
    >
      {children}
    </section>
  );
}

export default Card;